module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAUJJREFUOE+VUtFVwkAQnEkogBKwArECsQKxAqEC87jwLX5zG0MFQgVaAlagHYgVSAOX9S3m8mKU53N/ctnb2dmdOaKOLMv6SZLckBwDGNbpLYC1iGxiXfzSDvP5fFhV1SOAAclnAFtV7QMYATi1/xDCVVmW+wZoTGmavgGgsXnvjaWJPM8zVb0H8CQiVw0wz/OFqt6SvOiCYlGsSZLkbLlcvlqezrkdyZ333sb6NeqpPkjeee8XEagAViKSHQNavktgjHtV3RZFYWoeDeecEWxEZBIZ1wAuQwgnbdXaHWaz2YTkg6pOi6KwerC24sVUCyFMu+AsywZpmtr9u4hEf3HwMXYEsANQVlX1pRw5Jhl3/25HS3JT1aw57ywaX811/Yqmh6ZdNWy0Xq83sHzbV+ec7daAfwD/UDaCV/8C1n4aePQJ7GSYMUGB4AgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./app/images/search_icon.png
// module id = 1313
// module chunks = 0